import { getAssetPath } from '@stencil/core';

import { cdnUrl } from 'src/utils/constants';

export const getSvgContent = (url: string) => {
  const getIconUrl =
    process.env.NODE_ENV === 'development' ? getAssetPath(`.${url}`) : `${cdnUrl}${url}`;

  const request = fetch(getIconUrl).then(async res => {
    if (res.ok) {
      const svgString = await res.text();

      return {
        ok: res.ok,
        status: res.status,
        content: svgString,
      };
    } else {
      return {
        ok: res.ok,
        status: res.status,
        content: null,
      };
    }
  });

  return request;
};
